import { MessageOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { useCommunicationRights } from "../communication-permissions.ts"
import ComposerDrawer, { type ComposerTarget } from "./ComposerDrawer.tsx"

export const CommunicateButton = ({
  target,
  size = "large",
  label,
  onClosed
}: {
  target: ComposerTarget | null
  size?: "middle" | "large"
  label?: string
  onClosed?: () => void
}) => {
  const { t } = useTranslation()
  const rights = useCommunicationRights()
  const [open, setOpen] = useState(false)
  if (!rights.send || !target) return null
  return (
    <>
      <Tooltip title={t("communication.composer.communicate")}>
        <Button
          aria-label={t("communication.composer.communicate")}
          size={size}
          className="rounded-lg"
          icon={<MessageOutlined aria-hidden />}
          onClick={() => setOpen(true)}
        >
          {label}
        </Button>
      </Tooltip>
      <ComposerDrawer
        target={open ? target : null}
        onClose={() => {
          setOpen(false)
          onClosed?.()
        }}
      />
    </>
  )
}
